import { ViewMode } from './ui';

export enum LocalStorageKeys {
    VIEW_MODE = 'viewMode',
    PREFERRED_UNIVERSE = 'preferredUniverse',
    COOKIE_CONSENT = 'cookieConsent',
    PROFILE_SIDEBAR_COLLAPSED = 'profileSidebarCollapsed',
    SESSION_SYNC_LAST_KNOWN_USER_ID = 'sessionSyncLastKnownUserId',
    SESSION_SYNC_LAST_SYNCED_AT = 'sessionSyncLastSyncedAt',
}

export type CookieConsentStatus = 'accepted' | 'rejected';

export interface CookieConsentPreference {
    status: CookieConsentStatus;
    version: number;
    decidedAt: string;
}

export interface PreferredUniversePreference {
    slug: string;
    expiresAt: number;
}

export interface LocalStorageTypeMap {
    [LocalStorageKeys.VIEW_MODE]: ViewMode;
    [LocalStorageKeys.PREFERRED_UNIVERSE]: PreferredUniversePreference;
    [LocalStorageKeys.COOKIE_CONSENT]: CookieConsentPreference;
    [LocalStorageKeys.PROFILE_SIDEBAR_COLLAPSED]: boolean;
    [LocalStorageKeys.SESSION_SYNC_LAST_KNOWN_USER_ID]: number | null;
    [LocalStorageKeys.SESSION_SYNC_LAST_SYNCED_AT]: number;
}
